<!-- =========================================================================================
  File Name: VisitPointEdit.vue
  Description: Visit Point Create Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-edit">
		<vx-card>
			<vs-alert
				color="danger"
				:title="$t('VisitPoints.VisitPointNotFound.Title')"
				:active.sync="visit_point_not_found"
			>
				<span>{{
					$t("VisitPoints.VisitPointNotFound.Text1") +
					" " +
					$route.params.id +
					" " +
					$t("VisitPoints.VisitPointNotFound.Text2")
				}}</span>
				<span>
					<span>{{ $t("Check") }} </span>
					<router-link :to="{name: 'app-visit-point-list'}" class="text-inherit underline">{{
						$t("VisitPoints.AllVisitPoints")
					}}</router-link>
				</span>
			</vs-alert>
			<visit-point-edit-tab-account
				v-if="visitingPoints !== null && visitpointUpdatePermission"
				class="mt-4"
				:data="visitingPoints"
			/>
			<not-permission v-if="!visitpointUpdatePermission"></not-permission>
		</vx-card>
	</div>
</template>

<script>
import VisitPointEditTabAccount from "./VisitPointEditTabAccount.vue";
import NotPermission from "@/views/pages/NotPermission.vue";
import moduleCapacity from "@/store/capacity/moduleCapacity.js";
import moduleSkills from "@/store/skills/moduleSkills.js";

export default {
	components: {
		VisitPointEditTabAccount,
		NotPermission,
	},
	data() {
		return {
			visitingPoints: null,
			visit_point_not_found: false,
			capacityList: [],
		};
	},
	computed: {
		visitpointUpdatePermission() {
			return this.$store.getters.checkPermission("VISIT_POINT_U");
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getVisitPointById(visitPointId) {
			this.openLoading();
			this.$store
				.dispatch("moduleVisitPoint/findVisitPointPaginated", {id: [visitPointId]})
				.then((res) => {
					this.visitingPoints = res.records[0];
					this.closeLoading();
					return res.records;
				})
				.catch((err) => {
					this.closeLoading();
					this.visit_point_not_found = true;
					console.error(err);
				});
		},
	},
	created() {
		if (!moduleCapacity.isRegistered) {
			this.$store.registerModule("moduleCapacity", moduleCapacity);
			moduleCapacity.isRegistered = true;
		}
		if (!moduleSkills.isRegistered) {
			this.$store.registerModule("moduleSkills", moduleSkills);
			moduleSkills.isRegistered = true;
		}
		this.getVisitPointById(parseInt(this.$route.params.id));
	},
	beforeDestroy() {
		this.$store.commit("moduleCapacity/REMOVE_ALL_ASSIGNED_CAPACITY");
		this.$store.commit("moduleSkills/REMOVE_ALL_ASSIGNED_SKILL");
	},
};
</script>

<style lang="scss" scoped>
#page-user-edit {
	height: 30%;
}
</style>
